import { CrudManager } from "./CrudManager";

export default function AdminDepartments() {
  return (
    <CrudManager
      testidPrefix="admin-departments"
      title="Departments"
      description="Manage hospital departments."
      endpoint="/admin/departments"
      columns={[
        { key: "name", label: "Name" },
        { key: "icon", label: "Icon" },
        { key: "short_description", label: "Description" },
      ]}
      emptyValues={{ name: "", icon: "Stethoscope", short_description: "", description: "", image_url: "", services_list: [], order: 0 }}
      fields={[
        { name: "name", label: "Name", type: "text" },
        { name: "icon", label: "Lucide icon name", type: "text", placeholder: "Stethoscope" },
        { name: "short_description", label: "Short description", type: "textarea", rows: 2 },
        { name: "description", label: "Full description", type: "textarea", rows: 5 },
        { name: "image_url", label: "Image URL", type: "url" },
        { name: "services_list", label: "Services offered", type: "list" },
        { name: "order", label: "Display order", type: "number" },
      ]}
    />
  );
}
